import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../hooks/useLocale';
import { useOnboarding } from './OnboardingProvider';
import { EditSummaryForm } from '../cv/forms/EditSummaryForm';
import { CvEnrichmentNotice } from './web-step-chrome';

export function StepSummary() {
  const { t } = useTranslation('auth');
  const { isRTL } = useLocale();
  const { nextStep, prevStep } = useOnboarding();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <div style={{ maxWidth: 560, marginInline: 'auto', width: '100%' }}>
          <button onClick={prevStep} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, marginBottom: 12 }}>
            <ChevronLeft size={24} color="var(--text-primary)" style={isRTL ? { transform: 'scaleX(-1)' } : undefined} />
          </button>
          <h1 style={{ fontSize: 28, fontWeight: 600, letterSpacing: '-0.01em', marginBottom: 4 }}>
            <span style={{ color: 'var(--text-secondary)' }}>{t('onboarding.summary.titleBase', { defaultValue: 'Add your' })} </span>
            <span style={{ color: '#5a2aff' }}>{t('onboarding.summary.titleAccent', { defaultValue: 'summary' })}</span>
          </h1>
          <p style={{ fontSize: 15, color: 'var(--text-secondary)', marginBottom: 16 }}>{t('onboarding.summary.subtitle', { defaultValue: 'Your intro. AI writes the draft.' })}</p>
          <CvEnrichmentNotice />
          <EditSummaryForm onSave={nextStep} closeOnSave={false} ctaLabel={t('onboarding.next', { defaultValue: 'Next' })} sparkApplySkill={false} />
        </div>
      </div>
    </div>
  );
}
